import type {MaterialGraph} from "@cm/material-nodes"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"

export const materialLikeMarker = Symbol("MaterialLike")

export interface MaterialLikeNode extends FundamentalLikeNode<MaterialGraph | null> {
    readonly [materialLikeMarker]: true
}

export const materialMarker = createFundamentalMarker<MaterialLikeNode>(materialLikeMarker)
export const {isLikeNode: isMaterialLikeNode, isLikeNodeClass: isMaterialLikeNodeClass, like: materialLike} = materialMarker
